const _uknown_error_dp = (externalBaseUrl: string) => ({
	structure: {
		type: 'Page',
		styleId: 'p2',
		id: '_uknown_error_dp',
		components: [
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-iuqkrar1',
				dataQuery: '#dataItem-iuqkrars',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-iuqkrarv',
				componentType: 'wysiwyg.viewer.components.WRichText',
				parent: '_uknown_error_dp',
				layoutQuery: '#layout-lzzmsr3z19',
			},
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-iuqksom1',
				dataQuery: '#dataItem-iuqksoml',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-iuqksoml1',
				componentType: 'wysiwyg.viewer.components.WRichText',
				parent: '_uknown_error_dp',
				layoutQuery: '#layout-lzzmsr3z14',
			},
			{
				type: 'Component',
				styleId: 'style-ivs5pjao',
				id: 'comp-iuqkv7ht',
				dataQuery: '#dataItem-iuqkv7ij',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-lzzmsr3z8',
				componentType: 'wysiwyg.viewer.components.SiteButton',
				parent: '_uknown_error_dp',
				layoutQuery: '#layout-lzzmsr3z9',
			},
			{
				type: 'Component',
				styleId: 'wp2',
				id: 'comp-iuqlqwdz',
				dataQuery: '#dataItem-iuqlqwf7',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-iuqlqwfc',
				componentType: 'wysiwyg.viewer.components.WPhoto',
				parent: '_uknown_error_dp',
				layoutQuery: '#layout-lzzmsr3z4',
			},
		],
		mobileComponents: [
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-iuqkrar1',
				dataQuery: '#dataItem-iuqkrars',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-lzzmsr3z18',
				componentType: 'wysiwyg.viewer.components.WRichText',
				parent: '_uknown_error_dp',
				layoutQuery: '#layout-lzzmsr3z19',
			},
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-iuqksom1',
				dataQuery: '#dataItem-iuqksoml',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-lzzmsr3z13',
				componentType: 'wysiwyg.viewer.components.WRichText',
				parent: '_uknown_error_dp',
				layoutQuery: '#layout-lzzmsr3z14',
			},
			{
				type: 'Component',
				styleId: 'style-ivs5pjao',
				id: 'comp-iuqkv7ht',
				dataQuery: '#dataItem-iuqkv7ij',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'mobile_propItem-lzzmsr3z8',
				componentType: 'wysiwyg.viewer.components.SiteButton',
				parent: '_uknown_error_dp',
				layoutQuery: '#layout-lzzmsr3z9',
			},
			{
				type: 'Component',
				styleId: 'wp2',
				id: 'comp-iuqlqwdz',
				dataQuery: '#dataItem-iuqlqwf7',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-iuqlqwfc',
				componentType: 'wysiwyg.viewer.components.WPhoto',
				parent: '_uknown_error_dp',
				layoutQuery: '#layout-lzzmsr3z4',
			},
		],
		dataQuery: '#_uknown_error_dp',
		skin: 'wysiwyg.viewer.skins.page.TransparentPageSkin',
		layout: {
			x: 0,
			y: 0,
			height: 0,
			width: 0,
		},
		componentType: 'mobile.core.components.Page',
		layoutQuery: '#layout-lzzmsr3z',
	},
	data: {
		document_data: {
			_uknown_error_dp: {
				type: 'Page',
				id: '_uknown_error_dp',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				title: 'error',
				hideTitle: true,
				icon: '',
				descriptionSEO: '',
				metaKeywordsSEO: '',
				pageTitleSEO: '',
				pageUriSEO: 'error',
				hidePage: false,
				underConstruction: false,
				tpaApplicationId: 0,
				pageSecurity: {
					requireLogin: false,
				},
				isPopup: false,
				indexable: true,
				isLandingPage: true,
				pageBackgrounds: {
					desktop: {
						custom: true,
						ref: '#customBgImg3vn',
						isPreset: true,
					},
					mobile: {
						custom: true,
						ref: '#customBgImg24ta',
						isPreset: true,
					},
				},
				translationData: {
					uriSEOTranslated: false,
				},
				ignoreBottomBottomAnchors: true,
			},
			customBgImg24ta: {
				type: 'BackgroundMedia',
				id: 'customBgImg24ta',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				color: '#FFFFFF',
				alignType: 'top',
				fittingType: 'fill',
				scrollType: 'fixed',
			},
			customBgImg3vn: {
				type: 'BackgroundMedia',
				id: 'customBgImg3vn',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				color: '#FFFFFF',
				alignType: 'top',
				fittingType: 'fill',
				scrollType: 'fixed',
			},
			'dataItem-iuqkrars': {
				type: 'StyledText',
				id: 'dataItem-iuqkrars',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				text:
					'<h4 class="font_4" style="font-size:66px"><span style="color:#3EB8EA"><span style="font-size:66px"><span style="font-family:helvetica-w01-light,helvetica-w02-light,sans-serif">Awkward...</span></span></span></h4>',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
			},
			'dataItem-iuqksoml': {
				type: 'StyledText',
				id: 'dataItem-iuqksoml',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				text:
					'<p class="font_7" style="font-size:22px; line-height:1.7em"><span style="color:#184A56"><span style="font-family:helvetica-w01-light,helvetica-w02-light,sans-serif"><span style="font-size:22px">This page isn&rsquo;t available.</span></span></span></p>',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
			},
			'dataItem-iuqkv7ij': {
				type: 'LinkableButton',
				id: 'dataItem-iuqkv7ij',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				label: 'Go Home',
				link: '#dataItem-iwis0lzk',
			},
			'dataItem-iuqlqwf7': {
				type: 'Image',
				id: 'dataItem-iuqlqwf7',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				title: '',
				uri: '4167f5_355a3e17b02f4c58b61d1a2cfeca06d3~mv2.png',
				description: '',
				width: 400,
				height: 282,
				alt: '',
			},
			'dataItem-iwis0lzk': {
				type: 'ExternalLink',
				id: 'dataItem-iwis0lzk',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				url: externalBaseUrl,
				target: '_self',
			},
		},
		design_data: {},
		behaviors_data: {},
		connections_data: {},
		theme_data: {
			'style-ivs5pjao': {
				type: 'TopLevelStyle',
				id: 'style-ivs5pjao',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				style: {
					properties: {
						'alpha-bg': '0',
						'alpha-bgh': '1',
						'alpha-brd': '1',
						'alpha-brdh': '0',
						'alpha-txt': '1',
						'alpha-txth': '1',
						bg: '#3EB8EA',
						bgh: '#4EB7F5',
						'boxShadowToggleOn-shd': 'false',
						brd: '#4EB7F5',
						brdh: '#3D9BE9',
						brw: '2',
						fnt: 'normal normal normal 22px/1.4em helvetica-w01-light',
						rd: '40px',
						shd: '0px 1px 4px 0px rgba(0,0,0,0.6)',
						txt: '#4EB7F5',
						txth: '#FFFFF1',
					},
					propertiesSource: {
						'alpha-bg': 'value',
						'alpha-brdh': 'value',
						bg: 'value',
						bgh: 'value',
						brd: 'value',
						brdh: 'value',
						brw: 'value',
						fnt: 'value',
						rd: 'value',
						shd: 'value',
						txt: 'value',
						txth: 'value',
					},
					groups: {},
				},
				componentClassName: 'wysiwyg.viewer.components.SiteButton',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
			},
		},
		component_properties: {
			'mobile_propItem-iuqkrarv': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1,
				packed: true,
				overrideAlignment: 'center',
			},
			'mobile_propItem-iuqksoml1': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1,
				packed: true,
			},
			'propItem-iuqkrarv': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				brightness: 1,
				packed: true,
			},
			'propItem-iuqksoml1': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				brightness: 1,
				packed: true,
			},
			'propItem-iuqkv7ik': {
				type: 'ButtonProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				align: 'center',
				margin: 0,
			},
			'propItem-iuqlqwfc': {
				type: 'WPhotoProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				displayMode: 'fill',
				onClickBehavior: 'goToLink',
				effectName: 'none',
			},
			'propItem-lzzmsr3z8': {
				type: 'ButtonProperties',
				align: 'center',
				margin: 0,
				metaData: {
					schemaVersion: '1.0',
				},
				id: 'propItem-lzzmsr3z8',
			},
			'mobile_propItem-lzzmsr3z8': {
				type: 'ButtonProperties',
				align: 'center',
				margin: 0,
				metaData: {
					schemaVersion: '1.0',
				},
				fontScale: 0.863837598531476,
				id: 'mobile_propItem-lzzmsr3z8',
			},
			'propItem-lzzmsr3z13': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1,
				packed: true,
				fontScale: 0.6948499742213815,
				id: 'propItem-lzzmsr3z13',
			},
			'propItem-lzzmsr3z18': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1,
				packed: true,
				overrideAlignment: 'center',
				fontScale: 0.8084127123905273,
				id: 'propItem-lzzmsr3z18',
			},
		},
		variants_data: {},
		layout_data: {
			'layout-lzzmsr3z': {
				id: 'layout-lzzmsr3z',
				type: 'RefArray',
				values: ['#layout-lzzmsr3z1', '#layout-lzzmsr3z3'],
			},
			'layout-lzzmsr3z1': {
				id: 'layout-lzzmsr3z1',
				componentLayout: {
					type: 'ClassicComponentLayout',
					height: {
						type: 'auto',
					},
					width: {
						type: 'auto',
					},
				},
				containerLayout: {
					type: 'MeshContainerLayout',
					meshData: {
						contentHeight: 'auto',
					},
					contentArea: {
						width: {
							type: 'SystemVariable',
							value: 'siteWidth',
						},
						alignment: 'center',
					},
				},
				itemLayout: {},
				type: 'SingleLayoutData',
			},
			'layout-lzzmsr3z2': {
				id: 'layout-lzzmsr3z2',
				componentLayout: {
					type: 'ClassicComponentLayout',
					height: {
						type: 'auto',
					},
					width: {
						type: 'auto',
					},
				},
				containerLayout: {
					type: 'MeshContainerLayout',
					meshData: {
						contentHeight: 'auto',
					},
					contentArea: {
						width: {
							type: 'SystemVariable',
							value: 'siteWidth',
						},
						alignment: 'center',
					},
				},
				itemLayout: {},
				type: 'SingleLayoutData',
			},
			'layout-lzzmsr3z3': {
				id: 'layout-lzzmsr3z3',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzmsr3z2',
				from: '#_uknown_error_dp',
			},
			'layout-lzzmsr3z4': {
				id: 'layout-lzzmsr3z4',
				type: 'RefArray',
				values: ['#layout-lzzmsr3z5', '#layout-lzzmsr3z7'],
			},
			'layout-lzzmsr3z5': {
				id: 'layout-lzzmsr3z5',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 374,
					},
					height: {
						type: 'px',
						value: 264,
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 149,
						y: 107,
						width: 374,
						height: 264,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzmsr3z6': {
				id: 'layout-lzzmsr3z6',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 272,
					},
					height: {
						type: 'px',
						value: 196,
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 24,
						y: -7,
						width: 272,
						height: 196,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzmsr3z7': {
				id: 'layout-lzzmsr3z7',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzmsr3z6',
				from: '#comp-iuqlqwdz',
			},
			'layout-lzzmsr3z9': {
				id: 'layout-lzzmsr3z9',
				type: 'RefArray',
				values: ['#layout-lzzmsr3z10', '#layout-lzzmsr3z12'],
			},
			'layout-lzzmsr3z10': {
				id: 'layout-lzzmsr3z10',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 198,
					},
					height: {
						type: 'px',
						value: 56,
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 203,
						y: 561,
						width: 198,
						height: 56,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzmsr3z11': {
				id: 'layout-lzzmsr3z11',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 204,
					},
					height: {
						type: 'px',
						value: 56,
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 53,
						y: 366,
						width: 204,
						height: 56,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzmsr3z12': {
				id: 'layout-lzzmsr3z12',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzmsr3z11',
				from: '#comp-iuqkv7ht',
			},
			'layout-lzzmsr3z14': {
				id: 'layout-lzzmsr3z14',
				type: 'RefArray',
				values: ['#layout-lzzmsr3z15', '#layout-lzzmsr3z17'],
			},
			'layout-lzzmsr3z15': {
				id: 'layout-lzzmsr3z15',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 475,
					},
					height: {
						type: 'auto',
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 207,
						y: 482,
						width: 475,
						height: 37,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzmsr3z16': {
				id: 'layout-lzzmsr3z16',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 277,
					},
					height: {
						type: 'auto',
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 21,
						y: 292,
						width: 277,
						height: 52,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzmsr3z17': {
				id: 'layout-lzzmsr3z17',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzmsr3z16',
				from: '#comp-iuqksom1',
			},
			'layout-lzzmsr3z19': {
				id: 'layout-lzzmsr3z19',
				type: 'RefArray',
				values: ['#layout-lzzmsr3z20', '#layout-lzzmsr3z22'],
			},
			'layout-lzzmsr3z20': {
				id: 'layout-lzzmsr3z20',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 752,
					},
					height: {
						type: 'auto',
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 203,
						y: 379,
						width: 752,
						height: 81,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzmsr3z21': {
				id: 'layout-lzzmsr3z21',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 320,
					},
					height: {
						type: 'auto',
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 0,
						y: 202,
						width: 320,
						height: 78,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzmsr3z22': {
				id: 'layout-lzzmsr3z22',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzmsr3z21',
				from: '#comp-iuqkrar1',
			},
		},
		transformations_data: {},
	},
	title: 'error',
	pageUriSEO: 'error',
})

export default _uknown_error_dp
